import { render, staticRenderFns } from "./ContainerDetail.vue?vue&type=template&id=08a0c5fe&"
import script from "./ContainerDetail.vue?vue&type=script&lang=js&"
export * from "./ContainerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports